import { render, staticRenderFns } from "./citizen.vue?vue&type=template&id=19badf63"
import script from "./citizen.vue?vue&type=script&lang=js"
export * from "./citizen.vue?vue&type=script&lang=js"
import style0 from "./citizen.vue?vue&type=style&index=0&id=19badf63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports